import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  categoryForEdit: {
    categoryName: undefined,
    name: "",
    assetClassId: null,
    parentId: null,
  },
  message: null,
  messageType: null,
  showMessage: false,
  categoryId: undefined,
  title: undefined,
  showApproveDialog: false,
  showDeleteDialog: false,
  isCategory: false,
  isApprove: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const categorySlice = createSlice({
  name: "category",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // Category loader
    categoryListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    categoryList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadCategoryForEdit: (state, action) => {
      const payload = action.payload;

      state.categoryForEdit.categoryName = payload.category?.name;
      state.categoryForEdit.id = payload.category?.id;
      state.categoryForEdit.assetClassId =
        payload.category?.assetCategoryClass || "";
      state.categoryForEdit.attribute = payload.attribute;
      state.categoryForEdit.parentId = payload.category?.id;
    },
    loadCategoryMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    setApproveDialogData: (state, action) => {
      const { id, title, isCategory } = action.payload;

      state.isCategory = isCategory;
      state.categoryId = id;
      state.title = title;
      state.showApproveDialog = !state.showApproveDialog;
    },
    setDeleteDialogData: (state, action) => {
      const { id, title, isCategory } = action.payload;

      state.categoryId = id;
      state.isCategory = isCategory;
      state.title = title;
      state.showDeleteDialog = !state.showDeleteDialog;
    },
    setApproveStatus: (state, action) => {
      state.isApprove = action.payload;
    },
  },
});
